import * as React from 'react';

import { color } from '@coursera/coursera-ui';
import { SvgHelp } from '@coursera/coursera-ui/svg';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import type { Placement } from 'bundles/common/components/Tooltip';

type Props = {
  message: string | React.ReactNode;
  style?: React.CSSProperties;
  size?: number;
  placement?: Placement;
  tooltipClassName?: string;
  /**
   * svg title is disabled by default with the assumption that the tooltip is more helpful than icon title
   */
  suppressTitle?: boolean;
  /**
   * Show optional text before the Help icon, see QuizFeedbackHelp for example.
   */
  helpText?: React.ReactNode;
};

const HelpTooltip = ({
  message,
  helpText = null,
  size = 14,
  style = {},
  placement = 'top',
  tooltipClassName = 'help-tooltip',
  suppressTitle = true,
}: Props) => {
  return (
    <TooltipWrapper message={message} placement={placement} tooltipClassName={tooltipClassName}>
      {helpText}
      <SvgHelp
        size={size}
        color={color.primaryText}
        hoverColor={color.primary}
        style={Object.assign({ margin: '-2px 3px' }, style)}
        suppressTitle={suppressTitle}
      />
    </TooltipWrapper>
  );
};

export default HelpTooltip;
